import isDarkMode from "@helpers/isDarkMode";
import formatCurrency from '@format/priceWithCurrency';

export const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      '::placeholder': {
        color: '#AAAAAA',
      },
      color: isDarkMode() ? 'white' : 'black',
      fontFamily: 'Inter, sans-serif',
      fontSize: '16px',
      fontWeight: 'normal',
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  },
};

// @deprecated - use format.priceWithCurrency instead
export { formatCurrency };

const roundToTwoDecimals = (num: number): number => +(`${Math.round(Number(`${num}e+2`))}e-2`);
export const calculateTotalPriceInCents = (prices: number[]): number => roundToTwoDecimals((prices.reduce((acc, cur) => acc + cur, 0))
  * 100);
